import { de } from "date-fns/locale";
import { useEffect } from "react";
import { formatNameAndSurname } from "../Utils/format";

export const useGetAllPrimaryData = ({
    isSuccessSystemProcedures,
    isSuccessMyPanelList,
    isSuccessOngoingPlanListForToday,
    isErrorOngoingPlanListForToday,
    isSuccessGeneralOngoingPlanList,
    isErrorGeneralOngoingPlanList, 
    isSuccessEmergencyStopDataList,
    isErrorEmergencyStopDataList,

    systemProcedures,
    panelList,
    ongoingPlanListForTodayData,
    generalOngoingPlanListData,
    emergencyStopDataListData,
    setSystemPanels,
    setMyPanel,

    setOngoingPlanListData,
    setAllOngoingPlanListData,
    setBlockOngoingPlanListData,
    setBlockOngoingPlanListDataForToday,
    setEmergencyStopDataList,
}: any) => {


    useEffect(() => {
        if (isSuccessSystemProcedures) {
            setSystemPanels(systemProcedures.data)
        }
    }, [isSuccessSystemProcedures])

    useEffect(() => {
        if (isSuccessMyPanelList) {
            setMyPanel(panelList.data)
        }
    }, [isSuccessMyPanelList]);

    useEffect(() => {
        if (isSuccessOngoingPlanListForToday) {
            const planList = ongoingPlanListForTodayData?.data?.planList?.map((plan:any) => ({
                ...plan,
                patientFirstName: formatNameAndSurname(plan.patientFirstName),
                patientLastName: formatNameAndSurname(plan.patientLastName),
            }));
            const data = {
                ...ongoingPlanListForTodayData.data,
                planList: planList
            }
            setOngoingPlanListData(data)
            setBlockOngoingPlanListDataForToday(false)
        }
    }, [isSuccessOngoingPlanListForToday]);

    useEffect(() => {
        if (isErrorOngoingPlanListForToday) {
            setBlockOngoingPlanListDataForToday(false)
        }
    }, [isErrorOngoingPlanListForToday]);

    useEffect(() => {
        if (isSuccessGeneralOngoingPlanList) {
            const planList = generalOngoingPlanListData?.data?.planList?.map((plan:any) => ({
                ...plan,
                patientFirstName: formatNameAndSurname(plan.patientFirstName),
                patientLastName: formatNameAndSurname(plan.patientLastName),
            }));
            const data = {
                ...generalOngoingPlanListData?.data,
                planList: planList
            }
            setAllOngoingPlanListData(data)
            setBlockOngoingPlanListData(false)
        }
    }, [isSuccessGeneralOngoingPlanList]);

    useEffect(() => {
        if (isErrorGeneralOngoingPlanList) {
            setBlockOngoingPlanListData(false)
        }
    }, [isErrorGeneralOngoingPlanList]);

    useEffect(() => {
        if (isSuccessEmergencyStopDataList) {
            setEmergencyStopDataList(emergencyStopDataListData.data)
        }
    }, [isSuccessEmergencyStopDataList]);

    useEffect(() => {
        if (isErrorEmergencyStopDataList) {
            setEmergencyStopDataList([])
        }
    }, [isErrorEmergencyStopDataList]);
}